import {
    CREATED_SOLICITOR_GROUP_RESPONSE, FAILED_TO_GET_GROUPS_OF_SOLICITORS, LOGOUT, RECEIVE_GROUPS_OF_SOLICITORS,
    REQUEST_GET_GROUPS_OF_SOLICITORS
} from "../actions/index";
import {
    FAILED_TO_RECEIVE_SOLICITOR_GROUP_CASE_TYPES,
    GET_SOLICITOR_GROUP_CASE_TYPES,
    RECEIVE_BAD_REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES,
    RECEIVE_GET_SOLICITOR_GROUP_WORKSOURCES,
    RECEIVE_SOLICITOR_GROUP_CASE_TYPES,
    REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES,
    FAILED_TO_RECEIVE_GROUP_EXPENSES_CASE_TYPES, GET_GROUP_EXPENSES_CASE_TYPES,
    RECEIVE_GROUP_EXPENSES_CASE_TYPES,
} from "../actions";
const defaultState = {
    solicitorGroups: [],
    fetching: false,
    badResponse: '',
    fetchingSolicitorGroupCaseTypes: false,
    fetchingSolicitorGroupWorkSources: false,
    groupExpenseCaseTypes: []

};

export default (state = defaultState, action) => {
    switch (action.type) {
        case REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES:
            return {
                ...state,
                fetchingSolicitorGroupWorkSources: true
            };
        case RECEIVE_GET_SOLICITOR_GROUP_WORKSOURCES:
            return {
                ...state,
                fetchingSolicitorGroupWorkSources: false
            };
        case RECEIVE_BAD_REQUEST_GET_SOLICITOR_GROUP_WORKSOURCES:
            return {
                ...state,
                fetchingSolicitorGroupWorkSources: false
            };
        case GET_SOLICITOR_GROUP_CASE_TYPES:
            return {
                ...state,
                fetchingSolicitorGroupCaseTypes: true
            };
        case RECEIVE_SOLICITOR_GROUP_CASE_TYPES:
            return {
                ...state,
                fetchingSolicitorGroupCaseTypes: false
            };
        case FAILED_TO_RECEIVE_SOLICITOR_GROUP_CASE_TYPES:
            return {
                ...state,
                fetchingSolicitorGroupCaseTypes: false
            };
        case GET_GROUP_EXPENSES_CASE_TYPES:
            return {
                ...state,
                fetching: true
            };
        case RECEIVE_GROUP_EXPENSES_CASE_TYPES:
            return {
                ...state,
                fetching: false,
                groupExpenseCaseTypes: action.payload.body
            };
        case FAILED_TO_RECEIVE_GROUP_EXPENSES_CASE_TYPES:
            return {
                ...state,
                fetching: false
            };
        case CREATED_SOLICITOR_GROUP_RESPONSE:
            return {
                ...state,
                solicitorGroups: [action.payload, state.solicitorGroups]
            };
        case REQUEST_GET_GROUPS_OF_SOLICITORS:
            return {
                ...state,
                fetching: true
            };
        case RECEIVE_GROUPS_OF_SOLICITORS:
            return {
                ...state,
                fetching: false,
                solicitorGroups: action.payload
            };
        case FAILED_TO_GET_GROUPS_OF_SOLICITORS:
            return {
                ...state,
                fetching:false,
                badResponse: 'Failed to receive groups of solicitors'
            };
        case LOGOUT:
            return {
                ...defaultState
            };
        default:
            return state
    }
}